<template>
  <v-fade-transition>
    <div
      key="loadingMask"
      v-if="isShowLoadingMask"
      class="d-flex align-center justify-center"
      style="
        isolation: isolate;
        position: absolute;
        inset: 0;
        background-color: #ffffffaa;
        z-index: 1;
      "
    >
      <v-progress-circular
        color="primary"
        :size="70"
        :width="7"
        indeterminate
      ></v-progress-circular>
    </div>
  </v-fade-transition>
</template>

<script>
export default {
  props: {
    isLoading: {
      type: Boolean || Array,
      default: false,
    },
  },
  computed: {
    isShowLoadingMask() {
      if (Array.isArray(this.isLoading)) {
        this.isLoading.every(loading => loading);
      }
      return this.isLoading;
    },
  },
};
</script>

<style lang="scss" scoped></style>
